import { DMCoQuan, IDMCoQuan} from '../../he-thong/dm-co-quan/dm-co-quan';
export interface IDMSanPham{
    Id:number,
    IdNhomSanPham:number,
    Ten:string,
    TenNhomSanPham:string, 
    IdCoQuan:number,
    IdLoaiCoQuan: number,
    TenLoaiCoQuan: string,
    TenCoQuan: string,
    TrangThai:number,
    DungChung:number,
    MaSP:string,
    IdCapDoHeThong:number,
    ListCoQuan:DMCoQuan[],
    //IdDataCenter: number,
    //CPUDuocCap:number,
    //RAMDuocCap:number,
    //DISKDuocCap:number,
    //LuotTruyCap:number,
    //KetNoi:number,

}

export class DMSanPham implements IDMSanPham{
    Id:number=0;
    IdNhomSanPham:number=0;
    Ten:string="";
    TenNhomSanPham:string="";
    IdCoQuan:number=0;
    IdLoaiCoQuan: number=0;
    TenLoaiCoQuan: string="";
    TenCoQuan: string="";
    TrangThai:number=0;
    DungChung:number=0;
    MaSP:string="";
    IdCapDoHeThong:number=0;
    ListCoQuan:DMCoQuan[] = [];
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }    
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/sanpham/dm-san-pham/dm-san-pham.ts